export const ADD_NOTE = 'Favorite/Notes/ADD_NOTE';

export const REMOVE_NOTE = 'Favorite/Notes/REMOVE_NOTE';

export const CREATE_NOTE = 'Favorite/Notes/CREATE_NOTE';

export const DELETE_NOTE = 'Favorite/Notes/DELETE_NOTE';
